import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';

import { MATRIX_GREEN } from '../constants';

export function TypewriterText({ text, delay = 0, speed = 40, className = '', style = {}, cursor = true }: { text: string; delay?: number; speed?: number; className?: string; style?: React.CSSProperties; cursor?: boolean }) {
  const [displayed, setDisplayed] = useState('');
  const [started, setStarted] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const startTimer = setTimeout(() => setStarted(true), delay);
    return () => clearTimeout(startTimer);
  }, [delay]);

  useEffect(() => {
    if (!started) return undefined;
    let i = 0;
    const interval = setInterval(() => {
      i += 1;
      setDisplayed(text.slice(0, i));
      if (i >= text.length) {
        clearInterval(interval);
        setDone(true);
      }
    }, speed);
    return () => clearInterval(interval);
  }, [started, text, speed]);

  return (
    <span className={className} style={style}>
      {displayed}
      {cursor && !done && (
        <motion.span animate={{ opacity: [1, 0] }} transition={{ duration: 0.5, repeat: Infinity }} style={{ color: MATRIX_GREEN }}>
          _
        </motion.span>
      )}
    </span>
  );
}
